module.exports = __webpack_public_path__ + "img/paper-yellow-sm-min.69369e7b.jpg";